import Cookies from "universal-cookie";
import { CONFIG } from "./config";

const cookies = new Cookies();

// export function setCookie(cookieName: any, cookieValue: any, cookiePath = CONFIG.COOKIE_PATH) {
//     cookies.set(cookieName, cookieValue,
//         {
//             path: cookiePath,
//             expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
//             secure: true
//         },
//     );
// }

// Francisco - Tratando o secure para true para Https e false para Http
export function setCookie(cookieName: any, cookieValue: any, cookiePath = CONFIG.COOKIE_PATH) {
    const isSecure = window.location.protocol === "https:";

    cookies.set(cookieName, cookieValue,
        {
            path: cookiePath,
            expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            secure: isSecure,  // só será true se estiver rodando com HTTPS
            sameSite: 'lax'
        },
    );
}

export function removeCookie(cookieName: any, cookiePath = CONFIG.COOKIE_PATH) {
    cookies.remove(
        cookieName,
        {
            path: cookiePath
        }
    );
}

export function getCookie(cookieName: any) {
    return cookies.get(cookieName);
}
